/**
 * Retrieve the firebase ID associated to the current tasting funnel
 * @param {*} state
 * @returns {string}
 */
export const tastingFirebaseId = state => state.firebaseId

export const getTastings = state => state.tastings

export const getTastingById = state => id => {
  return state.tastings.find(el => el.id === id)
}

/**
 * Retrieve the current tasting based on the navigation
 * @param {*} state
 * @param {*} getters
 * @param {*} rootState
 * @returns {Tasting}
 */
export const currentTasting = (state, getters, rootState) => {
  const tastingId = rootState.route.params.tastingId

  return getters.getTastingById(tastingId)
}

/**
 * Retrieve the current tasting section based on the navigation
 * @param {*} state
 * @param {*} getters
 * @param {*} rootState
 * @returns {TastingSection}
 */
export const currentSection = (state, getters, rootState) => {
  const tasting = getters.currentTasting
  const sectionId = rootState.route.params.sectionId
  
  if (!sectionId) return null

  return tasting[`${sectionId}Screens`]
}

/**
 * Retrieve the current question list for the current section based on the navigation
 * @param {*} state
 * @param {*} getters
 * @returns {TastingQuestion[]}
 */
export const currentQuestionListForSection = (state, getters) => {
  const section = getters.currentSection

  if (!section) return []

  return section
    .filter(step => step.schema === 'tastingQuestions')
    .map(step => state.question.byId[step.id])
}

/**
 * Retrieve the current tasting question based on the navigation
 * @param {*} state
 * @param {*} getters
 * @param {*} rootState
 * @returns {TastingQuestion}
 */
export const currentTastingQuestion = (state, getters, rootState) => {
  const questionId = rootState.route.params.stepId

  return state.question.byId[questionId]
}

/**
 * 
 * @param {*} state 
 * @param {*} getters 
 * @param {*} rootState 
 * @returns 
 */

export const currentState= (state, getters, rootState) => {
  return state
}

/**
 * Retrieve the current tasting transition based on the navigation
 * @param {*} state
 * @param {*} getters
 * @param {*} rootState
 * @returns {TastingTransition}
 */
export const currentTastingTransition = (state, getters, rootState) => {
  const transitionId = rootState.route.params.stepId

  return state.transition.byId[transitionId]
}

/**
 * Retrieve the current tasting step
 * @param {*} state
 * @param {*} getters
 * @returns {TastingTransition | TastingQuestion}
 */
export const currentTastingStep = (state, getters) =>
  getters.currentTastingQuestion || getters.currentTastingTransition

/**
 * Retrieve the current step type
 * @param {*} state
 * @param {*} getters
 * @returns {'tastingQuestion' | 'tastingTransition'}
 */
export const currentStepType = (state, getters) => {
  const question = getters.currentTastingQuestion
  const transition = getters.currentTastingTransition

  return (question && question.contentType) || (transition && transition.contentType)
}

/**
 * Retrieve the current answer from the user for the current question based on the navigation
 * @param {*} state
 * @param {*} getters
 * @param {*} rootState
 * @returns {string | number}
 */
export const currentTastingAnswer = (state, getters, rootState) => {
  const answerId = currentTastingAnswerId(state, getters, rootState)

  return state.userResponses[answerId]
}

/**
 * Returns the current answer id based on the navigation
 * @param {*} state
 * @param {*} getters
 * @returns {string}
 */
export const currentTastingAnswerId = (state, getters) => {
  const tasting = getters.currentTasting
  const section = getters.currentSection
  const question = getters.currentTastingQuestion

  if (!tasting || !section || !question) return

  return `${tasting.id}.${section.id}.${question.id}`
}

/**
 * Retrieve the tastings associated to the current theme based on the navigation
 * @param {*} state
 * @param {*} getters
 */
export const currentThemeTastings = (state, getters) => {
  const theme = getters.currentTheme

  if (!theme) return []

  return theme.tastings.map(tastingId => getters.getTastingById(tastingId))
}
